import apiCall from "./apiCall";
// eslint-disable-next-line import/no-anonymous-default-export
export default {
  async createSupplierInvoice(data) {
    let response = await apiCall("supplier_invoices/create", data);
    return response;
  },
  async fetchSupplierInvoices(data) {
    let response = await apiCall(
      "supplier_invoices/list_supplier_invoices",
      data
    );
    return response;
  },
  async fetchSupplierInvoicesWz_balances(data) {
    let response = await apiCall(
      "supplier_invoices/list_supplier_invoices_with_balances",
      data
    );
    return response;
  },
  async fetchSupplierInvoicesReadyto_be_paid(data) {
    let response = await apiCall(
      "supplier/list_pending_supplier_invoices_to_set_4_payments",
      data
    );
    return response;
  },
  async fetchSupplierInvoices_4_payments(data) {
    let response = await apiCall(
      "supplier_invoices/list_supplier_invoices_pending_payments",
      data
    );
    return response;
  },
  async setInvoiceForPayment(data) {
    let response = await apiCall(
      "supplier_invoices/setInvoice_ready_for_payment",
      data
    );
    return response;
  },
  async addPartialPayment(data) {
    let response = await apiCall(
      "supplier_invoices/setInvoice_ready_for_payment",
      data
    );
    return response;
  },
};
